<template>
    <span v-b-tooltip.hover title="Remove">
        <i class="remove-resource icon-trash pointer-action" @click="removeResource(resource)" variant="warning"></i>
    </span>
</template>

<script>
export default {
    props: {
        resource: {
            required: true,
            type: Object,
        },
        removeResource: {
            required: true,
            type: Function,
        },
    },
}
</script>

<style>
.remove-resource {
    font-weight: 600;
}
</style>
